export default __webpack_public_path__ + "static/media/ic_binance.60a43ade.svg";